import type { ReactNode } from "react";

import { classes } from "./classes.js";

/**
 * `P0-UIK-001`. 4.6.3 gives two radii and they are not interchangeable:
 * `rounded-2xl` on CLIENT cards, `rounded-xl` on CONSOLE cards. The surface
 * chooses; the component does not guess, because a client card that looks like
 * a console card is a client app that looks like an internal tool.
 */
export type CardShape = "console" | "client";

export interface CardProps {
  readonly children: ReactNode;
  readonly shape?: CardShape;
  readonly className?: string;
  /** `F-0b`: the hooks the bank's scoped skin reads (`bank-theme.css`); no other app sets them. */
  readonly dataKit?: string;
  readonly dataTone?: string | undefined;
}

const SHAPES: Readonly<Record<CardShape, string>> = {
  console: "rounded-xl",
  client: "rounded-2xl",
};

export function Card({
  children,
  shape = "console",
  className,
  dataKit,
  dataTone,
}: CardProps): React.JSX.Element {
  return (
    <div
      data-kit={dataKit}
      data-tone={dataTone}
      className={classes("border border-gray-200 bg-white p-6", SHAPES[shape], className)}
    >
      {children}
    </div>
  );
}
